import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'Marco',
  city: 'Milano'
}, {
  name: 'Giulia',
  city: 'Roma'
}, {
  name: 'Alessandro',
  city: 'Napoli'
}, {
  name: 'Francesca',
  city: 'Torino'
}, {
  name: 'Luca',
  city: 'Bologna'
}, {
  name: 'Chiara',
  city: 'Firenze'
}, {
  name: 'Matteo',
  city: 'Palermo'
}, {
  name: 'Sara',
  city: 'Genova'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    // Hide after 6 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next one after 12-20 seconds
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-220">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} className="fixed bottom-4 left-4 sm:bottom-8 sm:left-8 z-50 max-w-[300px] w-full" data-id="element-221">
          <div className="bg-brand-card border border-brand-orange/50 rounded-xl p-4 shadow-[0_0_20px_rgba(249,115,22,0.2)] relative overflow-hidden group" data-id="element-222">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange to-brand-gold" data-id="element-223" />

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-white" data-id="element-224">
              <XIcon className="w-4 h-4" data-id="element-225" />
            </button>

            <div className="flex items-center gap-3" data-id="element-226">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-orange to-brand-amber flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-227">
                {currentBuyer.name.charAt(0)}
              </div>
              <div data-id="element-228">
                <p className="text-sm text-gray-200 font-medium leading-tight" data-id="element-229">
                  <span className="font-bold text-brand-cream" data-id="element-230">
                    {currentBuyer.name}
                  </span>{' '}
                  da {currentBuyer.city} ha appena acquistato il Sistema
                  Integrato Italiano™
                </p>
                <div className="flex items-center gap-2 mt-1" data-id="element-231">
                  <span className="flex items-center gap-1 text-xs text-green-400 font-bold" data-id="element-232">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-233" />
                    Verificato
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-234">
                    {timeAgo} minuti fa
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}